import { render } from "./popup_child.vue?vue&type=template&id=7538bb1c"
import script from "./popup_child.vue?vue&type=script&lang=js"
export * from "./popup_child.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__